import copy from 'copy-to-clipboard';
import { Tooltip } from 'antd';
import {
  ArrowRightOutlined,
  CopyOutlined,
  LikeOutlined,
} from '@ant-design/icons';

export const zendeskUrlButton = (zendeskUrl) => ({
  text: (
    <>
      <ArrowRightOutlined /> View Ticket in Zendesk
    </>
  ),
  ghost: false,
  type: 'link',
  target: 'zendesk_url',
  href: zendeskUrl,
});

export const renderCopyTooltipText = (copied) => {
  return copied ? (
    <span>
      Link Copied <LikeOutlined />
    </span>
  ) : (
    'Copy Link'
  );
};

export const copyZendeskLinkButton = (url, copied, setCopied) => ({
  text: (
    <>
      <Tooltip
        title={
          copied ? (
            <span>
              Link Copied <LikeOutlined />
            </span>
          ) : (
            'Copy Link'
          )
        }
      >
        <CopyOutlined /> Copy Ticket Link
      </Tooltip>
    </>
  ),
  ghost: false,
  type: 'link',
  onClick: () => {
    setCopied(true);
    copy(url);
  },
});
